"use client";

import { useEffect, useState } from "react";
import { Button, Drawer, Menu, Layout, Modal } from "antd";
const { Header } = Layout;
import { FaBars, FaTimes } from "react-icons/fa";
import Image from "next/image";
import logo from "@/assets/images/logo.png";
import servicesIcon from "@/assets/icons/services1.png";
import services2Icon from "@/assets/icons/services2.png";

import { IoIosArrowDown, IoIosArrowUp, IoMdMenu } from "react-icons/io";

import { useRouter, usePathname } from "next/navigation";

import PrimaryButton from "@/components/PrimaryButton";
import { CLIENT_API_ROUTES } from "@/utils/clientApiRoutes";
import axios from "axios";
import { HiOutlineServer } from "react-icons/hi2";
import Headline from "./Home/Headline";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [selectedBar, setSelectedBar] = useState("menu");
  const [hasHeadline, setHasHeadline] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const router = useRouter();
  const pathname = usePathname();

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const [servicesByCategory, setServicesByCategory] = useState([]);
  const [serviceItems, setServiceItems] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const [serRes] = await Promise.all([
          await axios.get(CLIENT_API_ROUTES?.GET_SERVICES_BY_CATEGORY),
        ]);

        const servicesByCategory = serRes?.data?.servicesByCategory || [];
        setServicesByCategory(servicesByCategory);

        const serviceItems = servicesByCategory.map((item, ci) => ({
          label: item?.category,
          coreService: item?.coreService,
          key: ci + 1,
          className: "",
          children: item?.services?.map((service, si) => ({
            label: service?.title,
            className: "",
            key: `${ci + 1}-${si + 1}`,
            onClick: () =>
              (window.location.href = `/services/${service?.slug}`),
          })),
        }));

        setServiceItems(serviceItems || []);
      } catch (err) {
        console.error("Error Fetching services by category:", err?.message);
        setServiceItems([]);
      }
    };

    getData();
  }, []);

  const navItems = [
    { key: 1, label: "Home", onClick: () => router.push("/"), className: "" },
    {
      key: 2,
      label: "About Us",
      onClick: () => router.push("/about"),
      className: "",
    },
    {
      key: 3,
      label: (
        <div className="relative z-[100] group h-[5rem]">
          <button className="flex  h-full justify-center items-center">
            <div>Services</div>
            <div className="pl-1">
              <IoIosArrowDown className={`inline group-hover:hidden `} />{" "}
              <IoIosArrowUp className="hidden group-hover:inline " />
            </div>
          </button>
          {/* Dropdown menu */}
          <div
            className={`fixed left-0 ${
              hasHeadline && !isScrolled ? "top-[8rem]" : "top-[5rem]"
            }  w-full z-[999] text-black overflow-hidden transition-all duration-100 ease-in-out max-h-0 group-hover:max-h-full`}
          >
            <div
              style={{
                backgroundImage: `url(${servicesIcon.src}), url(${services2Icon.src})`,
                backgroundPosition: "left center, right center",
                backgroundRepeat: "no-repeat, no-repeat",
                backgroundSize: "40% auto, 50% auto",
              }}
              className="w-full border-b-8 max-h-[70vh] overflow-y-auto border-[#063c63f5] p-4 md:p-8 grid grid-cols-1 md:grid-cols-6 gap-3 md:gap-6 bg-primary text-white  flex-col items-start"
            >
              {/* Overlay */}
              <div className="absolute inset-0 bg-[#084c7cf5]"></div>
              <div className="absolute animate-bounce top-[80%] right-2">
                <IoIosArrowDown className="text-xl" />
              </div>

              {servicesByCategory?.length > 0 &&
                servicesByCategory?.map((item, i) => (
                  <div
                    className={`relative h-full ${
                      item?.coreService ? "bg-[#ffffffe7] rounded-lg" : "bg-[#fdba6e23] rounded-lg"
                    } p-2 z-10 flex text-start text-wrap flex-col justify-start items-start gap-2`}
                    key={i}
                  >
                    <div
                      className={`${
                        item?.coreService
                          ? "text-[#d48d3b] border-b border-[#fdbb6e] pb-2 "
                          : "pb-2 text-[#ffffff] border-b border-b-[#ffffff38]"
                      } text-base font-bold `}
                    >
                      {item?.category}
                    </div>

                    <div
                      className={`mt-1 md:mt-3 flex flex-col ${
                        item?.coreService ? "text-primary" : "text-[#ffffffdc]"
                      } font-medium  gap-2 items-start justify-center`}
                    >
                      {item?.services.map((service, i) => (
                        <p
                          onClick={() =>
                            (window.location.href = `/services/${service?.slug}`)
                          }
                          key={i}
                          className={`${
                            item?.coreService
                              ? "hover:text-[#c9a882]"
                              : "hover:text-blue-400"
                          }`}
                        >
                          {service?.title}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ),
      className: "",
    },
    {
      key: 4,
      label: "News & Articles",
      onClick: () => router.push("/article"),
      className: "",
    },
    {
      key: 5,
      label: "Careers",
      onClick: () => router.push("/career"),
      className: "",
    },
    {
      key: 6,
      label: "Gallery",
      onClick: () => router.push("/gallery"),
      className: "",
    },
  ];

  const sideItems = [
    { key: 1, label: "Home", onClick: () => router.push("/"), className: "" },
    {
      key: 2,
      label: "About Us",
      onClick: () => router.push("/about"),
      className: "",
    },
    {
      key: 3,
      label: "News & Articles",
      onClick: () => router.push("/article"),
      className: "",
    },
    {
      key: 4,
      label: "Careers",
      onClick: () => router.push("/career"),
      className: "",
    },

    {
      key: 5,
      label: "Gallery",
      onClick: () => router.push("/gallery"),
      className: "",
    },
    {
      key: 6,
      label: "Contact Us",
      onClick: () => router.push("/contact"),
      className: "",
    },
  ];

  // const serviceItems = [
  //   {
  //     key: 1,
  //     label: "Service",
  //     onClick: () => router.push("/"),
  //     className: "",
  //   },
  //   {
  //     key: 2,
  //     label: "About Us",
  //     onClick: () => router.push("/about"),
  //     className: "",
  //   },
  //   {
  //     key: 3,
  //     label: "Services",
  //     onClick: () => router.push("/about"),
  //     className: "",
  //   },
  //   {
  //     key: 4,
  //     label: "Career",
  //     onClick: () => router.push("/about"),
  //     className: "",
  //   },
  //   {
  //     key: 5,
  //     label: "Articles",
  //     onClick: () => router.push("/article"),
  //     className: "",
  //   },
  //   {
  //     key: 6,
  //     label: "Gallery",
  //     onClick: () => router.push("/about"),
  //     className: "",
  //   },
  // ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0); // If page is scrolled down even by 1px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="h-full relative w-full">
        <Headline hasHeadline={hasHeadline} setHasHeadline={setHasHeadline} />
        <Header
          style={{
            boxShadow:
              "0px 317px 89px 0px rgba(0, 0, 0, 0.00), 0px 203px 81px 0px rgba(0, 0, 0, 0.01), 0px 114px 69px 0px rgba(0, 0, 0, 0.03), 0px 51px 51px 0px rgba(0, 0, 0, 0.04), 0px 13px 28px 0px rgba(0, 0, 0, 0.05)",
          }}
          className={`w-full flex flex-col justify-center p-0 shadow-md
                 bg-[#F7F7F7] font-normal text-black h-[5rem] z-[100] transition-all duration-300 ease-in-out ${
                   isScrolled ? "fixed inset-0 " : ""
                 } `}
        >
          <div className="h-20 w-[95%] mx-auto flex gap-2 xl:gap-4 justify-between lg:justify-center items-center">
            <Image
              onClick={() => router.push("/")}
              src={logo}
              alt="Logo"
              className="h-18 max-w-[14rem] xl:max-w-[24rem] object-contain cursor-pointer"
            />

            <Button
              className="block lg:hidden bg-primary border "
              type="primary"
              onClick={showDrawer}
            >
              <FaTimes
                className={`${open ? "block" : "hidden"}  text-xl text-white`}
              />
              <FaBars
                className={`${open ? "hidden" : "block"}  text-xl text-white`}
              />
            </Button>

            <Menu
              id="navmenu"
              className="hidden w-[45%] min-w-[39rem] font-manrope h-full lg:flex justify-start items-center
                mx-1 xl:mx-4 text-center bg-[#F7F7F7] text-base whitespace-nowrap"
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={["1"]}
              items={navItems}
            />

            <div className="hidden lg:block w-fit min-w-[10rem]">
              <PrimaryButton text={"Contact Us"} link="/contact" />
            </div>
          </div>
        </Header>
      </div>

      {/* Side Drawer */}
      <Drawer
        id="custom-drawer"
        className="text-secondary font-segoe w-max max-w-sm bg-[#F7F7F7] p-4"
        styles={{
          mask: { backgroundColor: "transparent" }, // Ensure no color or opacity
        }}
        placement={"left"}
        closable={false}
        onClose={onClose}
        open={open}
      >
        <div className="flex justify-start items-start gap-1">
          <Image
            onClick={() => router.push("/")}
            src={logo}
            alt="Logo"
            className="h-18 max-w-[16rem] md:max-w-[16rem] xl:max-w-[24rem] object-contain cursor-pointer"
          />
          <FaTimes
            onClick={() => setOpen(false)}
            className={`text-xl text-primary`}
          />
        </div>

        <div className="flex justify-start text-base items-start gap-4 font-semibold ">
          <p
            onClick={() => setSelectedBar("menu")}
            className={`text-primary pb-2 ${
              selectedBar === "menu" && "border-b-2 border-b-primary"
            } `}
          >
            <IoMdMenu className="inline text-lg" /> Menu
          </p>
          <p
            onClick={() => setSelectedBar("services")}
            className={`text-primary pb-2 ${
              selectedBar === "services" && "border-b-2 border-b-primary"
            } `}
          >
            {" "}
            <HiOutlineServer className="inline text-lg" /> Services
          </p>
        </div>

        <div className="flex gap-3 justify-start items-start">
          <Menu
            id="sideDrawer"
            className="w-full h-full bg-white text-xl "
            theme="dark"
            defaultSelectedKeys={["1"]}
            mode="inline"
            items={selectedBar === "menu" ? sideItems : serviceItems}
          />
        </div>
      </Drawer>
    </>
  );
};
export default Navbar;
